import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { repossessedPropertyTypes } from 'constants/enums/financialOptions';
import { hasYesOrNo } from 'models/validate';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { setToStartOfMonth } from 'helpers/date';
import { FinancialRepossessionItemModel } from '../types';
import { pvqRepossessionLocationValidator } from './pvqRepossessionLocationValidator';

export const pvqFinancialRepossessionItemValidator: ValidateJSModel<FinancialRepossessionItemModel> = {
  LenderName: { hasValue: true },

  PropertyType: {
    hasValue: {
      validator: {
        inclusion: {
          within: repossessedPropertyTypes,
        },
      },
    },
  },

  PropertyTypeExplain: (value, attributes) => {
    if (attributes?.PropertyType?.value === 'Other personal property') {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  FirstPastDue: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireMonth: true,
      requireYear: true,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
    },
  }),

  AmountOwed: {
    model: {
      validator: currencyModelValidator,
    },
  },

  NumberMissed: { hasValue: true },

  Why: { hasValue: true },

  When: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireMonth: true,
      requireYear: true,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST,
    },
  }),

  WhenEstimated: {},

  AccountNum: (value, attributes) => {
    if (attributes?.AccountNumIdk?.applicable !== false) {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },

  AccountNumIdk: {},

  Current: {
    presence: true,
    hasValue: {
      validator: hasYesOrNo,
    },
  },

  WhenResolved: (value, attributes, attributeName, options) => {
    if (attributes?.Current?.value === 'No') {
      return {
        presence: true,
        date: {
          requireMonth: true,
          requireYear: true,
          earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
          latest: DEFAULT_LATEST,
        },
      };
    }

    return {};
  },

  WhenResolvedEstimated: {},

  ActionsTaken: (value, attributes) => {
    if (attributes?.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable !== false) {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  ActionsTakenReason: (value, attributes) => {
    if (attributes?.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable === false) {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  CourtName: (value, attributes) => {
    if (attributes?.CourtNameNotApplicable?.applicable !== false) {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  CourtNameNotApplicable: {},

  CourtLocation: (value, attributes) => {
    if (attributes?.CourtNameNotApplicable?.applicable !== false) {
      return {
        presence: true,
        location: {
          validator: pvqRepossessionLocationValidator,
          requireCounty: false,
        }
      };
    }

    return {};
  },

  OrderNum: (value, attributes) => {
    if (attributes?.OrderNumIdk?.applicable !== false  && attributes?.CourtNameNotApplicable?.applicable !== false) {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  OrderNumIdk: {},
};
